import DescriptionInput from './DescriptionInput';

export default DescriptionInput;
